<!--  -->
<template>
  <el-button v-bind="$attrs" :type="buttonType" @click="throttledClick" :icon="iconType">
    <slot name="default"></slot>
  </el-button>
</template>

<script>
import { throttle } from 'lodash';
export default {
  name: 'jhButton',
  components: {},
  props: {
    type: {
      type: String,
      defalut: ''
    },
    icon: {
      type: String,
      default: ''
    },
    delay: {
      type: Number,
      default: 2000
    }
  },

  data() {
    return {
      throttledClick: null,
      timer: null,
      defaultType: {
        primary: 'primary',
        info: 'info',
        success: 'success',
        text: 'text',
        warning: 'warning',
        danger: 'danger',
        default: ''
      },
      iconMap: {
        add: 'el-icon-plus',
        edit: 'el-icon-edit',
        delete: 'el-icon-delete',
        download: 'el-icon-download',
        upload: 'el-icon-upload2',
        search: 'el-icon-search',
        cancel: 'el-icon-close',
        save: 'el-icon-document',
        confirm: 'el-icon-check',
        refresh: 'el-icon-refresh',
        operation: 'el-icon-s-operation',
        back: 'el-icon-back',
        finish: 'el-icon-finished',
        preview: 'el-icon-monitor',
        list: 'el-icon-tickets',
        print: 'el-icon-printer'
      }
    };
  },

  computed: {
    buttonType() {
      //默认是primary 传default是边框按钮
      if (!this.type) {
        return 'primary';
      }
      return this.defaultType[this.type] || '';
    },
    iconType() {
      return this.iconMap[this.icon] || this.icon;
    }
  },
  created() {
    this.throttledClick = throttle(
      (event) => {
        this.$emit('click', event);
      },
      this.delay,
      { leading: true, trailing: false }
    );
  }
};
</script>
<style lang="scss" scoped></style>
